import { ConnectionState } from 'livekit-client';
/**
 * Что делать, чтобы оказаться в комнате под нужным identity.
 *
 * livekit-client при уже установленном соединении выходит из connect() немедленно
 * («already connected to room»), поэтому повторный вызов с другим identity молча
 * ничего не менял: участник навсегда оставался под предварительным случайным id,
 * и вся адресная логика (модерация, разрешение входа) промахивалась мимо него.
 */
export function planIdentityConnect(_a) {
    var state = _a.state, currentIdentity = _a.currentIdentity, desiredIdentity = _a.desiredIdentity, isJoined = _a.isJoined;
    if (state !== ConnectionState.Connected) {
        return 'connect';
    }
    if (currentIdentity === desiredIdentity) {
        return 'skip';
    }
    // Смена identity — это разрыв соединения. Во время активного звонка это
    // означало бы потерю медиа, поэтому здесь identity уже не меняем.
    if (isJoined) {
        return 'skip';
    }
    return 'reconnect';
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29ubmVjdGlvbklkZW50aXR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL2hvb2tzL2Nvbm5lY3Rpb25JZGVudGl0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0sZ0JBQWdCLENBQUM7QUFXakQ7Ozs7Ozs7R0FPRztBQUNILE1BQU0sVUFBVSxtQkFBbUIsQ0FBQyxFQUtWO1FBSnhCLEtBQUssV0FBQSxFQUNMLGVBQWUscUJBQUEsRUFDZixlQUFlLHFCQUFBLEVBQ2YsUUFBUSxjQUFBO0lBRVIsSUFBSSxLQUFLLEtBQUssZUFBZSxDQUFDLFNBQVMsRUFBRSxDQUFDO1FBQ3hDLE9BQU8sU0FBUyxDQUFDO0lBQ25CLENBQUM7SUFFRCxJQUFJLGVBQWUsS0FBSyxlQUFlLEVBQUUsQ0FBQztRQUN4QyxPQUFPLE1BQU0sQ0FBQztJQUNoQixDQUFDO0lBRUQsd0VBQXdFO0lBQ3hFLGtFQUFrRTtJQUNsRSxJQUFJLFFBQVEsRUFBRSxDQUFDO1FBQ2IsT0FBTyxNQUFNLENBQUM7SUFDaEIsQ0FBQztJQUVELE9BQU8sV0FBVyxDQUFDO0FBQ3JCLENBQUMifQ==